module.exports = __webpack_public_path__ + "img/hero3.894ca1cd.webp";